import React from "react";
import { all, call, put, select, takeLatest } from "redux-saga/effects";

import { FacetsData } from "@/mk2/apps/bazaar/components/FacetsFilter";
import {
    Checked,
    HER_BAZAAR_LOAD,
    HerBazaarLoadAction,
    HerBazaarLoadNormalizedResponse,
    herBazaarLoadApi,
} from "@/mk2/apps/bazaar/containers/HerBazaar/HerBazaar.actions";
import { FilterType } from "@/mk2/apps/bazaar/schemas";
import { XHRAction, XHRGetError, handleXHRGetErrorSaga, normalizeError } from "@/mk2/helpers/api";
import { getLogger } from "@/mk2/logger";
import { HistoryAction, redirectInPWA } from "@/mk2/services/browserHistory";
import { PAGE_SLUG } from "@/mk/autogenerated/translation";
import { bazaar_api_v3_products_url } from "@/mk/urls/functions";

const logger = getLogger("bazaar/HerBazaar.sagas");

interface LoadApiResponse {
    body: {
        facets: FacetsData;
        hits: number;
        checked: Checked;
        entities: HerBazaarLoadNormalizedResponse["entities"];
        result: HerBazaarLoadNormalizedResponse["result"];
    };
}

function* load({
    xhr,
    username,
    filter,
    location,
    routeNavigate,
}: HerBazaarLoadAction & XHRAction & HistoryAction) {
    yield put(herBazaarLoadApi.request(username, filter));

    try {
        const response: LoadApiResponse = yield call(() =>
            xhr.post(bazaar_api_v3_products_url(), {
                filter,
                filterType: FilterType.HER_BAZAAR,
            }),
        );

        yield put(
            herBazaarLoadApi.success(
                username,
                filter,
                response.body.facets,
                response.body.hits,
                response.body.checked,
                {
                    entities: response.body.entities,
                    result: response.body.result,
                },
            ),
        );
    } catch (error) {
        if (
            error.status === 404 &&
            error.response &&
            error.response.body.page &&
            error.response.body.page !== filter?.page
        ) {
            const newPage = error.response.body.page;
            const url = `${location.pathname}${location.search}${location.hash}`;
            redirectInPWA(
                routeNavigate,
                url.replace(
                    new RegExp(`${PAGE_SLUG}-\\d+/`),
                    newPage === 1 ? "" : `${PAGE_SLUG}-${newPage}/`,
                ),
                302,
            );
        } else {
            yield handleXHRGetErrorSaga(error as XHRGetError, location, routeNavigate, logger);
            yield put(herBazaarLoadApi.failure(username, filter, normalizeError(error)));
        }
    }
}

export default function* root() {
    yield all([takeLatest(HER_BAZAAR_LOAD, load)]);
}
